var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDefaultAvatar = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 360,
    viewBox: "0 0 350 360",
    fill: "none",
    id: "svg60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 359.64691,
    fill: "#000000",
    id: "rect49",
    x: 0,
    y: 0,
    style: {
      strokeWidth: 1.01369
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 218.936,214.41023 -2.716,-11.7139 c -1.188,-10.09983 6.054,-7.45304 10.525,-29.56596 1.335,0.7305 2.419,0.83957 3.904,0.83957 7.112,0 6.111,-9.22922 8.488,-22.31806 3.188,-17.55985 4.592,-18.85972 -2.377,-19.12991 1.342,-4.78122 4.923,-28.36513 4.923,-36.580574 0,-27.426705 -12.126,-56.760696 -65.659,-56.760696 -47.576,0 -61.828,30.984505 -61.828,54.914851 0,7.966879 5.936,33.376019 6.79,38.426419 -6.538,0.97267 -8.487,2.85293 -4.243,19.12991 2.931,11.24259 2.896,22.31806 10.015,22.31806 1.479,0 1.905,-0.10907 3.226,-0.83957 4.478,22.10592 10.864,17.78701 7.792,29.56596 l -2.528,11.7139 c -35.8842,4.57609 -81.6548,23.99619 -102.1954,47.48804 0,0 -15.6176,16.6132 -13.7501,66.61794 0.2919,7.81528 0.44742,30.77128 0.44742,30.77128 L 331.147,359.82763 V 328.3481 c 0,-55.03913 -14.429,-66.44983 -14.429,-66.44983 -13.922,-21.31038 -61.897,-41.43696 -97.782,-47.48804 z",
    fill: "url(#paint0_linear_2003_1402)",
    id: "path51",
    style: {
      fill: "url(#paint0_linear_2003_1402)",
      strokeWidth: 1.00034
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs58"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2003_1402",
    x1: 175.15401,
    y1: 359.13901,
    x2: 175.15401,
    y2: -0.169001,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(1,0,0,1.0006752,0,-0.02645292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    id: "stop53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0,
    id: "stop55"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultAvatar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/defaultAvatar.d4e78d98a3b3094f029c637d69bf2a33.svg";